import { Link } from 'react-router-dom';
import React, { useState, useEffect, useContext } from 'react';
import logo from '../../assets/images/bluesky-vue-logo.png';
import classnames from 'classnames';
import LinearProgress from '@material-ui/core/LinearProgress';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import { selfInspectLogin } from '../../services';
import { AppContext } from '../../AppContext';
import queryString from 'query-string';

var { version: appVersion } = require('../../../package.json');

const SelfInspectLogin = props => {
  const [formData, setFormData] = useState({
    lname: '',
  });
  const [loginLoading, setLoginLoading] = useState(false);
  const [loginError, setLoginError] = useState('');
  const [query] = useState(queryString.parse(props.history.location.search));

  const { state, dispatch } = useContext(AppContext);

  const attemptAuthentication = async evt => {
    evt.preventDefault();
    setLoginError('');
    setLoginLoading(true);

    if (!formData.lname) {
      setLoginError('Last name is required');
      setLoginLoading(false);
      return;
    }

    if (!query.OrderLineGuid) {
      setLoginError('Order not found');
      setLoginLoading(false);
      return;
    }

    const loginData = {
      lname: formData.lname,
      OrderLineGuid: query.OrderLineGuid, // '90D9C223-75FA-40B5-A857-CEDFCA23B6E9'
    };

    try {
      const inspectorData = await selfInspectLogin(loginData);

      const orderLineId = inspectorData?.user?.orderlineService.find(
        ols => ols?.orderline?.orderLineGuid?.toLowerCase() === query.OrderLineGuid?.toLowerCase(),
      )?.orderline?.orderLineId;

      if (orderLineId) {
        props.history.push(`/orders/review/${orderLineId}`);
      } else {
        setLoginError('Order not found');
      }

      setLoginLoading(false);
    } catch (error) {
      console.log(error);
      setLoginLoading(false);
      setLoginError('Verification failed.  Please try again');
    }
  };

  const updateField = field => event => {
    setFormData({
      ...formData,
      [field]: event.target.value,
    });
  };

  const checkOrder = () => {
    /**
     * 1. get order guid from url
     * 2. answer auth questions
     * 3. get auth token
     */
  };

  useEffect(() => {
    checkOrder();
  }, []);

  return (
    <div className={classnames('app', 'login-background', 'col-center-center')}>
      <div
        className={classnames('login-card')}
        style={{
          margin: '30px auto',
        }}
      >
        <div className={classnames('login-card-left', 'col-center-center')}>
          <img src={logo} alt={'BlueSky Vue Logo'} style={{ maxWidth: '100%', height: 'auto' }} />
        </div>
        <div className={classnames('login-card-right', 'col-center-center')}>
          <form id="login-form" style={{ width: '90%' }} onSubmit={attemptAuthentication}>
            <div
              style={{
                fontSize: 28,
              }}
              className="mb-10 blue-text text-bold"
            >
              Self Inspect Portal
            </div>

            <Typography variant="body2" className="text-hint" style={{ marginBottom: 15 }}>
              Welcome to the JMI self inspect portal. Please verify your email, address number, and auth code to sign
              in.
            </Typography>

            <div className="col-start-start">
              <label>Please verify your last name</label>
              <TextField
                value={formData.lname}
                margin="dense"
                variant="outlined"
                inputProps={{ 'aria-label': 'bare' }}
                style={{ width: '100%' }}
                onChange={updateField('lname')}
              />
            </div>

            <div style={{ marginTop: 20 }} className={classnames('row-center-center', 'full-width')}>
              <button type="submit" className="login-submit-button">
                Start Inspection
              </button>
            </div>
          </form>

          <div className="login-card-submit-details">
            {loginError && <div className="login-card-error">{loginError}</div>}
            {loginLoading && <LinearProgress className="login-card-loading" />}
          </div>
        </div>
      </div>
      <div style={{ margin: '25px auto', color: '#aaa', fontSize: 14 }}>Version {appVersion}</div>
    </div>
  );
};

SelfInspectLogin.propTypes = {};

export default SelfInspectLogin;
